<template>
  <div class="tw:border tw:shadow-xs tw:p-3 tw:rounded-lg  tw:text-foreground tw:[&_a]:break-all">
    <slot />
  </div>
</template>

<script setup>
</script>
